import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { A11yModule } from '@angular/cdk/a11y';
import { OverlayModule } from '@angular/cdk/overlay';

import { SedsHeaderMenuComponent } from './seds-header-menu.component';

import { SedsViewFixDirective } from '../../seds-header/directive/seds-view-fix.directive';
import { SedsHoverLiDirective } from '../../seds-header/directive/seds-hover-li.directive';
@NgModule({
  declarations: [SedsHeaderMenuComponent, SedsViewFixDirective, SedsHoverLiDirective],
  imports: [CommonModule, MatIconModule, OverlayModule, A11yModule],
  exports: [SedsHeaderMenuComponent],
})
export class SedsHeaderMenuModule {}
